export const getSchema = ({
  t,
  appealReasons,
}: {
  t: (id: string, obj?: Object) => string,
  appealReasons: Array<Object>,
}) => {
  return {
    type: "object",
    required: ["reasonForAppeal", "dateReceived", "additionalNotes"],
    properties: {
      dateReceived: {
        type: "string",
        title: t("DATE_RECEIVED"),
        format: "date-time",
      },
      reasonForAppeal: {
        type: "object",
        required: ["id"],
        title: t("REASON_FOR_APPEAL"),
        properties: {
          id: {
            type: "integer",
            title: t("REASON_FOR_APPEAL"),
            oneOf: appealReasons
              .filter(el => el.isActive)
              .map(reason => ({
                title: reason.name,
                const: reason.id,
              })),
          },
        },
      },
      appealForm: {
        type: ["string", "null"],
        title: t("APPEAL_FORM"),
        pattern:
          "^(data:([a-z]+\\/[^;]+)?(;charset=[^;]+)?(;name=[^;]+)?(;base64)?,.*$|https?:\\/\\/.+)$",
      },
      additionalNotes: {
        type: "string",
        title: t("ADDITIONAL_NOTES"),
        maxLength: 2000,
      },
    },
    urn: "urn:jsonschema:eu:firstcare:api:v1:dto:tools:tasks:AppealsReviewDTO",
  };
};
